import React from 'react';
import { Globe } from 'lucide-react';
export function GlobalReach() {
  const languages = [{
    text: 'REVEAL YOURSELF',
    lang: 'English'
  }, {
    text: 'بَيِّن',
    lang: 'Arabic'
  }, {
    text: 'MUESTRATE',
    lang: 'Spanish'
  }, {
    text: '展现你自己',
    lang: 'Chinese'
  }, {
    text: 'REVELE TOI',
    lang: 'French'
  }, {
    text: 'खुद को प्रकट करो',
    lang: 'Hindi'
  }, {
    text: 'SVELATI',
    lang: 'Italian'
  }, {
    text: '自分自身を明らかにする',
    lang: 'Japanese'
  }];
  return <section id="global" className="py-16 bg-[#f0f7ff]" data-id="element-81">
      <div className="container mx-auto px-4" data-id="element-82">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-3xl mx-auto" data-id="element-83">
          <div className="flex items-center justify-center mb-8" data-id="element-84">
            <div className="bg-black text-white font-bold py-2 px-4 rounded-md" data-id="element-85">
              A GLOBAL REACH
            </div>
          </div>
          <div className="flex justify-center mb-8" data-id="element-86">
            <h3 className="text-2xl font-bold text-blue-500" data-id="element-87">SportProZ</h3>
          </div>
          <div className="text-center space-y-2 mb-8" data-id="element-88">
            {languages.map((item, index) => <p key={index} className="text-gray-800 font-medium" data-id="element-89">
                {item.text} <span className="text-gray-500" data-id="element-90">({item.lang})</span>
              </p>)}
          </div>
          <div className="flex justify-center space-x-4" data-id="element-91">
            <a href="mailto:info@sportproz.com" className="bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-2 px-4 rounded-md transition-colors" data-id="element-92">
              EMAIL
            </a>
            <a href="https://wa.link/3zpoi0" className="bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-2 px-4 rounded-md transition-colors" data-id="element-93">
              WHATSAPP
            </a>
          </div>
        </div>
      </div>
    </section>;
}